import React, { useState, useRef, useEffect, useContext } from "react";
import { useTranslation } from "react-i18next";
import no_history from "../assets/home/no_history.png";

const NoOrderHistory = () => {
  const { t, i18n } = useTranslation();
  return (
    <>
      <div className="container-fluid bg clearall">
        <div className="Notification_sec">
          <img className="no_img" src={no_history} />
          <h3>{t("contest.no")}</h3>
          <h5>{t("contest.noDetails")} </h5>
        </div>  
      </div>
    </>
  );
};

export default NoOrderHistory;
